var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8703_52505)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00019 13.3002C8.67106 13.3002 10.2735 12.6364 11.455 11.455C12.6364 10.2735 13.3002 8.67106 13.3002 7.00019C13.3002 5.32933 12.6364 3.7269 11.455 2.54542C10.2735 1.36394 8.67106 0.700195 7.00019 0.700195C5.32933 0.700195 3.7269 1.36394 2.54542 2.54542C1.36394 3.7269 0.700195 5.32933 0.700195 7.00019C0.700195 8.67106 1.36394 10.2735 2.54542 11.455C3.7269 12.6364 5.32933 13.3002 7.00019 13.3002Z",
    stroke: "red",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 3.84961V6.64961",
    stroke: "red",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9999 10.1443C6.90708 10.1443 6.81805 10.1075 6.75242 10.0418C6.68678 9.97619 6.6499 9.88716 6.6499 9.79434C6.6499 9.70151 6.68678 9.61249 6.75242 9.54685C6.81805 9.48121 6.90708 9.44434 6.9999 9.44434",
    stroke: "red",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 10.1443C7.09283 10.1443 7.18185 10.1075 7.24749 10.0418C7.31313 9.97619 7.35 9.88716 7.35 9.79434C7.35 9.70151 7.31313 9.61249 7.24749 9.54685C7.18185 9.48121 7.09283 9.44434 7 9.44434",
    stroke: "red",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8703_52505"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.a9ff6642d91587f5874998714c0fc4b2.svg";
export { ForwardRef as ReactComponent };